import { Splide } from "@splidejs/splide";
import { Intersection } from '@splidejs/splide-extension-intersection';
import gsap from 'gsap';
import { CustomEase } from "gsap/CustomEase";


const carousel = () => {
  gsap.registerPlugin(CustomEase);

  const mvVisualSliderElm = document.querySelector('.js-mvVisualSlider');
  const mvVisualNavElm = document.querySelector('.js-mvVisualNav');

  const intervalTime = 4400;
  const durationTime = 400;

  const mvVisualSlider = new Splide(mvVisualSliderElm, {
    type: "fade",
    loop: true,
    speed: durationTime,
    autoplay: true,
    interval: intervalTime,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    pagination: false,
    drag: false,
    easing: 'ease-in-out',
  });

  const mvVisualNav = new Splide(mvVisualNavElm, {
    type: "fade",
    loop: true,
    speed: durationTime,
    rewind: true,
    autoplay: true,
    interval: intervalTime,
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false,
    pagination: false,
    drag: false,
    easing: 'ease-in-out',
  });

  const fadeRatio = durationTime / intervalTime / 2;

  CustomEase.create("myEase", "M0,0 C0.126,0.382 0.282,1.004 1,1");
  mvVisualSlider.on('autoplay:playing', (rate) => {
    if (rate < 1 - fadeRatio) {
      gsap.set(mvVisualNavElm, {
        "--indicator-scale": rate * (1 / (1 - fadeRatio)),
        "--indicator-path": '0%'
      });
    } else {
      // スライド切り替えフェーズ（fade中）
      gsap.to(mvVisualNavElm, {
        "--indicator-path": '100%',
        duration: durationTime / 1000,
        ease: "myEase",
        onComplete() {
          gsap.set(mvVisualNavElm, {
            "--indicator-scale": 0,
            "--indicator-path": '0%',
          });
        }
      });
    }
  });




  mvVisualSlider.sync( mvVisualNav );
  mvVisualSlider.mount();
  mvVisualNav.mount();


  const sceneModalSliderElms = document.querySelectorAll('.js-sceneModalSlider');
  sceneModalSliderElms.forEach( (elm) => {
    const sceneModalSlider = new Splide(elm, {
      type: "fade",
      loop: true,
      rewind: true,
      speed: 500,
      autoplay: true,
      interval: 3500,
      easing: 'ease-in-out',
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      pagination: true,
    });
    sceneModalSlider.mount( { Intersection } );
  });
}

const init = () => {
  carousel();
}
export default init;